module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Fan-6a6fe7aa545baee0bea185a6b3ab48d6.svg";